const types = {
  updateState: 'UPDATE_STATE',
  reset: 'RESET',
}
    
export default types
